export interface IContextMenu {
  name: string;   // name of event
  text: string;   // displayed text
  iconCls?: string; // icon class
}
